import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Row, Col, Spin } from "antd";
import DecisionDashboardTable from "./table";
import { createEntityNameLink } from "components/entity-name-link";
import {
    columnBuilder,
    rowBuilder
} from "../companies/utilities/table-utils";
// import table_column from "./extras/columns.json";
// import table_row from "./extras/rows.json";
import {Map, List} from "immutable";
import {
    fetchDesisioningDashboardColumns,
    fetchDesisioningDashboardRows
} from "./actions";
import { STATE_STATUS } from "../../constants";
import { ellipsisText, ellipsisTextWithHtml } from "components/ellipsis-text";
class DecisionDasboard extends React.Component{

    state = {
        page: 1
    }

    componentDidMount() {
        this.props.fetchDesisioningDashboardColumns();
        this.props.fetchDesisioningDashboardRows(this.state.page, 20, {}, this.props.stageId);
    }

    fetchRows = (page, pageSize, filters) => {
        this.props.fetchDesisioningDashboardRows(page, pageSize, filters, this.props.stageId);
        this.setState({
            page: page
        });
    }
    
    renderTable = () => {
        return (
            <DecisionDashboardTable
                user={this.props.user}
                stagePermissions={this.props.stagePermissions}
                history={this.props.history}
                currentStage={this.props.stageId}
                location={this.props.location}
                loading={(this.props.row.getIn([this.state.page, "status"]) || STATE_STATUS.FETCHING) === STATE_STATUS.FETCHING}
                fetchData={this.fetchRows}
                totalEntries={this.props.row.get("count") || 0}
                currentPage={this.state.page}
                permissions={this.props.permissions}
                columns={columnBuilder(
                    this.props.columnsData,
                    true
                ).map(_ => {
                    if(_.dataType !== 6){
                        if(_.key === "Dealer"){
                            return {
                                ..._, 
                                render: (__, record) => {
                                    return createEntityNameLink()(__, record, false, true);
                                }
                            };
                        } else if(_.key === "Remarks") {
                            return {
                                ..._, 
                                render: (_, record) => ellipsisTextWithHtml(_, record["Remarks HTML"])
                            };
                        } else if(_.key === "Sales Trend") {
                            return {
                                ..._, 
                                render: (_) => _ && parseInt(_)+"%" || "--" 
                            };
                        } else {
                            return { 
                                ..._, 
                                render: (_) => ellipsisText(_)
                            };
                        }
                    } else {
                        return _;
                    }
                })}
                rows={rowBuilder(
                    ((this.props.row.getIn([this.state.page, "data"]) || new List([])).toJS() || []),
                    true
                )}
            />
        );
    }
    
    render() {
        return (
            <Row className={"decision-dashboard-table-row"}>
                {/* <Row
                    style={{
                        background: "#fff",
                        borderBottom: "1px solid #e8e8e8"
                    }}
                    span={24} 
                    className={"p-10 d-flex align-items-center"}
                >
                    <Icon onClick={() => this.props.history.goBack()} style={{fontSize: "20px"}} type={"arrow-left"} />
                    <h1 style={{
                        fontSize: "24px",
                        margin: 0,
                        marginLeft: "16px"
                    }}>Decisioning Dashboard</h1>
                </Row>
                <Col span={24} className={"mt-5 pr-5 pl-5"}>
                    <Row> */}
                <Col span={24} className={"inbox-cases-table-col"}>
                    {
                        this.props.columnsStatus === STATE_STATUS.FETCHED ? 
                            this.renderTable() : 
                            <div className={"d-flex flex-row justify-content-center"}>
                                <Spin />
                            </div>
                    }
                </Col>
                {/* </Row>
                </Col> */}
            </Row>
        );
    }
}

DecisionDasboard.propTypes = {
    history: PropTypes.object,
    location: PropTypes.object,
    permissions: PropTypes.object,
    fetchDesisioningDashboardColumns: PropTypes.func,
    fetchDesisioningDashboardRows: PropTypes.func,
    columnsStatus: PropTypes.string,
    columnsData: PropTypes.array,
    row: PropTypes.object,
    stageId: PropTypes.number,
    user: PropTypes.object,
    stagePermissions: PropTypes.array
};


const mapStateToProps = (state, params) => {
    return {
        stageId: params.match.params.stageId,
        stagePermissions: state.stagePermissions.get("data") || new List([]),
        user: state.user.get("data") || new Map({}),
        permissions: state.user.get("permissions") || new Map({}),
        columnsStatus: state.decisioningDashboard.getIn(["columns", "status"]),
        columnsData: state.decisioningDashboard.getIn(["columns", "data"]),
        row: state.decisioningDashboard.get("rows") || new Map({})
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchDesisioningDashboardColumns,
            fetchDesisioningDashboardRows
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DecisionDasboard);